export * from './lib/select-input.component.module';

export {
  SelectInputOption,
  SelectInputOptionWithDynamicLabel,
  SelectInputComponent,
} from './lib/select-input.component';
